import { ADMIN_PATHS } from '../../../constants/adminPaths';
import { ADMIN_PERMISSIONS } from '../../../constants/permissions';

export const ADMIN_SIDEBAR_ITEMS = [
  { text: 'Dashboard', path: ADMIN_PATHS.DASHBOARD, permission: ADMIN_PERMISSIONS.DASHBOARD.VIEW },
  { text: 'Demos', path: ADMIN_PATHS.DEMOS, permission: ADMIN_PERMISSIONS.DEMOS.VIEW },
  { text: 'Impersonation', path: ADMIN_PATHS.IMPERSONATION, permission: ADMIN_PERMISSIONS.IMPERSONATION.VIEW },
  { text: 'Users', path: ADMIN_PATHS.USERS, permission: ADMIN_PERMISSIONS.USERS.VIEW },
  { text: 'Support Tickets', path: ADMIN_PATHS.SUPPORT, permission: ADMIN_PERMISSIONS.SUPPORT.VIEW },
  { text: 'Contact Messages', path: ADMIN_PATHS.CONTACT_SUBMISSIONS, permission: ADMIN_PERMISSIONS.CONTACT_SUBMISSIONS.VIEW },
  { text: 'Settings', path: ADMIN_PATHS.SETTINGS, permission: ADMIN_PERMISSIONS.SETTINGS.VIEW },
  { text: 'Admin Tools', path: ADMIN_PATHS.TOOLS, permission: ADMIN_PERMISSIONS.ADMIN.MANAGE },
];

const DEFAULT_SECTIONS = [
  { label: 'Overview', paths: [ADMIN_PATHS.DASHBOARD] },
  { label: 'Workspace', paths: [ADMIN_PATHS.DEMOS, ADMIN_PATHS.IMPERSONATION, ADMIN_PATHS.USERS] },
  { label: 'Inbox', paths: [ADMIN_PATHS.SUPPORT, ADMIN_PATHS.CONTACT_SUBMISSIONS] },
  { label: 'Account', paths: [ADMIN_PATHS.SETTINGS, ADMIN_PATHS.TOOLS] },
];

const SUPPORT_SECTIONS = [
  { label: 'Overview', paths: [ADMIN_PATHS.SUPPORT, ADMIN_PATHS.IMPERSONATION] },
  { label: 'Workspace', paths: [ADMIN_PATHS.USERS, ADMIN_PATHS.DEMOS, ADMIN_PATHS.DASHBOARD] },
  { label: 'Inbox', paths: [ADMIN_PATHS.CONTACT_SUBMISSIONS] },
  { label: 'Account', paths: [ADMIN_PATHS.SETTINGS, ADMIN_PATHS.TOOLS] },
];

export function buildAdminSidebarSections(visibleItems, isSupportRole) {
  const byPath = new Map(visibleItems.map((item) => [item.path, item]));
  const templates = isSupportRole ? SUPPORT_SECTIONS : DEFAULT_SECTIONS;

  return templates
    .map((section) => ({
      label: section.label,
      items: section.paths.map((path) => byPath.get(path)).filter(Boolean),
    }))
    .filter((section) => section.items.length > 0);
}
